export function formatQuantity (number) {
    if (number !== undefined) {
        return number.toLocaleString();
    }
}



// WEBPACK FOOTER //
// ./src/services/format.js